module.exports = __webpack_public_path__ + "media/images/flags/1x1/arg-0400e6762cad20c0df40fd11f48afe16.svg";